<template>
  <Teleport to="body">
    <div class="matricule-modal-overlay" @click="$emit('close')">
      <div class="matricule-modal-container" @click.stop>
        <!-- Header -->
        <div class="matricule-modal-header">
          <div class="header-icon-box">
            <i class="fas fa-car"></i>
          </div>
          <div class="header-text">
            <h3>🚗 Matricule de la Voiture</h3>
            <p>Veuillez saisir le matricule de la voiture du technicien</p>
          </div>
          <button class="close-button" @click="$emit('close')">
            <i class="fas fa-times"></i>
          </button>
        </div>

        <!-- Body -->
        <div class="matricule-modal-body">
          <div class="info-alert">
            <i class="fas fa-info-circle"></i>
            <span>Cette information sera affichée sur le bon de sortie pour la police</span>
          </div>

          <div class="form-field">
            <label>Matricule de la voiture *</label>
            <div class="input-container">
              <i class="fas fa-car-side input-icon"></i>
              <input
                ref="inputRef"
                v-model="localMatricule"
                type="text"
                placeholder="Ex: 123 TU 4567"
                @keyup.enter="handleConfirm"
              />
            </div>
            <span class="hint">Format: XXX TU XXXX ou XXX-TU-XXXX</span>
          </div>
        </div>

        <!-- Footer -->
        <div class="matricule-modal-footer">
          <button class="btn-cancel" @click="$emit('close')">
            <i class="fas fa-times"></i>
            Annuler
          </button>
          <button 
            class="btn-confirm" 
            @click="handleConfirm"
            :disabled="!localMatricule || localMatricule.trim() === ''"
          >
            <i class="fas fa-check"></i>
            Générer le Bon de Sortie
          </button>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script>
import { ref, onMounted } from 'vue'

export default {
  name: 'MatriculeVoitureModal',
  emits: ['close', 'confirm'],
  setup(props, { emit }) {
    const localMatricule = ref('')
    const inputRef = ref(null)

    const handleConfirm = () => {
      if (localMatricule.value && localMatricule.value.trim() !== '') {
        emit('confirm', localMatricule.value.trim())
      }
    }

    onMounted(() => {
      // Focus sur l'input après le montage
      setTimeout(() => {
        if (inputRef.value) {
          inputRef.value.focus()
        }
      }, 100)
    })

    return {
      localMatricule,
      inputRef,
      handleConfirm
    }
  }
}
</script>

<style scoped>
.matricule-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999999;
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.matricule-modal-container {
  background: #ffffff;
  border-radius: 20px;
  width: 95%;
  max-width: 520px;
  box-shadow: 0 25px 80px rgba(0, 0, 0, 0.4);
  animation: slideUp 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
  overflow: hidden;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(30px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

/* Header */
.matricule-modal-header {
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
  color: white;
  padding: 1.5rem 2rem;
  display: flex;
  align-items: center;
  gap: 1rem;
}

.header-icon-box {
  width: 50px;
  height: 50px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  flex-shrink: 0;
}

.header-text {
  flex: 1;
}

.header-text h3 {
  margin: 0 0 0.25rem 0;
  font-size: 1.25rem;
  font-weight: 700;
}

.header-text p {
  margin: 0;
  font-size: 0.9rem;
  opacity: 0.9;
}

.close-button {
  width: 36px;
  height: 36px;
  background: rgba(255, 255, 255, 0.2);
  border: none;
  border-radius: 10px;
  color: white;
  font-size: 1rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  flex-shrink: 0;
}

.close-button:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: rotate(90deg);
}

/* Body */
.matricule-modal-body {
  padding: 2rem;
  background: #ffffff;
}

.info-alert {
  background: linear-gradient(135deg, rgba(59, 130, 246, 0.1) 0%, rgba(37, 99, 235, 0.05) 100%);
  border: 1px solid rgba(59, 130, 246, 0.3);
  border-radius: 12px;
  padding: 1rem 1.25rem;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1.5rem;
}

.info-alert i {
  color: #3b82f6;
  font-size: 1.25rem;
  flex-shrink: 0;
}

.info-alert span {
  color: #1e40af;
  font-size: 0.9rem;
  line-height: 1.4;
}

.form-field {
  margin-bottom: 0;
}

.form-field label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 600;
  color: #1e293b;
  font-size: 0.95rem;
}

.input-container {
  position: relative;
  display: flex;
  align-items: center;
}

.input-icon {
  position: absolute;
  left: 1rem;
  color: #3b82f6;
  font-size: 1.1rem;
  z-index: 1;
}

.input-container input {
  width: 100%;
  padding: 1rem 1rem 1rem 3rem;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  font-size: 1rem;
  font-weight: 500;
  color: #1e293b;
  background: #f8fafc;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.input-container input:focus {
  outline: none;
  border-color: #3b82f6;
  background: #ffffff;
  box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.1);
}

.input-container input::placeholder {
  text-transform: none;
  letter-spacing: normal;
  color: #94a3b8;
  font-weight: 400;
}

.hint {
  display: block;
  margin-top: 0.5rem;
  font-size: 0.85rem;
  color: #64748b;
  font-style: italic;
}

/* Footer */
.matricule-modal-footer {
  padding: 1.25rem 2rem;
  background: #f8fafc;
  border-top: 1px solid #e2e8f0;
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
}

.btn-cancel,
.btn-confirm {
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 10px;
  font-weight: 600;
  font-size: 0.9rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  transition: all 0.3s ease;
}

.btn-cancel {
  background: #64748b;
  color: white;
}

.btn-cancel:hover {
  background: #475569;
  transform: translateY(-2px);
}

.btn-confirm {
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
  color: white;
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
}

.btn-confirm:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(59, 130, 246, 0.4);
}

.btn-confirm:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
}

/* Responsive */
@media (max-width: 600px) {
  .matricule-modal-container {
    width: 95%;
    margin: 1rem;
  }

  .matricule-modal-header {
    padding: 1.25rem 1.5rem;
    flex-wrap: wrap;
  }

  .header-icon-box {
    width: 44px;
    height: 44px;
    font-size: 1.25rem;
  }

  .header-text h3 {
    font-size: 1.1rem;
  }

  .matricule-modal-body {
    padding: 1.5rem;
  }

  .matricule-modal-footer {
    padding: 1rem 1.5rem;
    flex-direction: column;
  }

  .btn-cancel,
  .btn-confirm {
    width: 100%;
    justify-content: center;
  }
}
</style>
